import { createSlice } from '@reduxjs/toolkit';
import { func_validation } from 'functions';

export const mobileLicenseKeySlices = createSlice({
	name: 'mobileLicenseKey',
	initialState: {},
	reducers: {
		setLicenseComId: (state, action) => {
			state.licensePackageComId = action?.payload
		},
		setLicensePackageName: (state, action) => {
			state.licensePackagePackageName = action?.payload
		},
		getPackageList_request: (state) => {
			state.getPackageList_requesting = true;
			state.getPackageList_isSuccessful = undefined;
		},
		getPackageList_success: (state, action) => {
			state.getPackageList_requesting = false;
			state.getPackageList_isSuccessful = true;
            
			state.packageNameList =  action?.payload?.data;
		},
		getPackageList_failure: (state) => {
			state.getPackageList_requesting = false;
			state.getPackageList_isSuccessful = false;
		},
		getLicensePackage_request: (state) => {
			state.getLicensePackage_requesting = true;
			state.getLicensePackage_isSuccessful = undefined;
		},
		getLicensePackage_success: (state, action) => {
			state.getLicensePackage_requesting = false;
			state.getLicensePackage_isSuccessful = true;
            
			let data =  action?.payload?.data;
			state.licensePackage = func_validation.isObjectNotEmpty(data)? data:[]
            state.licensePackageHeaders = action?.payload?.headers
		},
		getLicensePackage_failure: (state) => {
			state.getLicensePackage_requesting = false;
			state.getLicensePackage_isSuccessful = false;
		},
		switchTrial_request: (state) => {
			state.switchTrial_requesting = true;
			state.switchTrial_isSuccessful = undefined;
		},
		switchTrial_success: (state, action) => {
			state.switchTrial_requesting = false;
			state.switchTrial_isSuccessful = true;
		},
		switchTrial_failure: (state) => {
			state.switchTrial_requesting = false;
			state.switchTrial_isSuccessful = false;
		},
		updateDeleteDate_request: (state) => {
			state.updateDeleteDate_requesting = true;
			state.updateDeleteDate_isSuccessful = undefined;
		},
		updateDeleteDate_success: (state, action) => {
			state.updateDeleteDate_requesting = false;
			state.updateDeleteDate_isSuccessful = true;
		},
		updateDeleteDate_failure: (state) => {
			state.updateDeleteDate_requesting = false;
			state.updateDeleteDate_isSuccessful = false;
		},
		generateLicense_request: (state) => {
			state.generateLicense_requesting = true;
			state.generateLicense_isSuccessful = undefined;
		},
		generateLicense_success: (state, action) => {
			state.generateLicense_requesting = false;
			state.generateLicense_isSuccessful = true;
		},
		generateLicense_failure: (state) => {
			state.generateLicense_requesting = false;
			state.generateLicense_isSuccessful = false;
		},
		extendDate_request: (state) => {
			state.extendDate_requesting = true;
			state.extendDate_isSuccessful = undefined;
		},
		extendDate_success: (state, action) => {
			state.extendDate_requesting = false;
			state.extendDate_isSuccessful = true;
		},
		extendDate_failure: (state) => {
			state.extendDate_requesting = false;
			state.extendDate_isSuccessful = false;
		},
		getLicenseReport_request: (state) => {
			state.getLicenseReport_requesting = true;
			state.getLicenseReport_isSuccessful = undefined;
		},
		getLicenseReport_success: (state, action) => {
			state.getLicenseReport_requesting = false;
			state.getLicenseReport_isSuccessful = true;
            
			let data =  action?.payload?.data;
			state.licenseReport = func_validation.isObjectNotEmpty(data)? data:[]
            state.licenseReportHeaders = action?.payload?.headers
		},
		getLicenseReport_failure: (state) => {
			state.getLicenseReport_requesting = false;
			state.getLicenseReport_isSuccessful = false;
		},
		exportLicenseReport_request: (state) => {
			state.exportLicenseReport_requesting = true;
			state.exportLicenseReport_isSuccessful = undefined;
		},
		exportLicenseReport_success: (state, action) => {
			state.exportLicenseReport_requesting = false;
			state.exportLicenseReport_isSuccessful = true;
		},
		exportLicenseReport_failure: (state) => {
			state.exportLicenseReport_requesting = false;
			state.exportLicenseReport_isSuccessful = false;
		},
	},
});

export const { 
	setLicenseComId,
	setLicensePackageName,
	getPackageList_request,
    getPackageList_success,
    getPackageList_failure,
	getLicensePackage_request,
    getLicensePackage_success,
    getLicensePackage_failure,
	switchTrial_request,
    switchTrial_success,
    switchTrial_failure,
	updateDeleteDate_request,
    updateDeleteDate_success,
    updateDeleteDate_failure,
	generateLicense_request,
    generateLicense_success,
    generateLicense_failure,
	extendDate_request,
    extendDate_success,
    extendDate_failure,
	getLicenseReport_request,
    getLicenseReport_success,
    getLicenseReport_failure,
	exportLicenseReport_request,
	exportLicenseReport_success,
	exportLicenseReport_failure
} = mobileLicenseKeySlices.actions;

export default mobileLicenseKeySlices.reducer;